import moment from 'jalali-moment'
import { UseMutateFunction } from 'react-query'
import { AxiosResponse } from 'axios'
import DotsLoading from 'components/loadings/dotsLoading'
import { useLocation, useNavigate } from 'react-router-dom'
interface IPayload {
    id: string | undefined
    loanId: number
}
interface IItemProps {
    item: IDemandResult
    isLoading: boolean
    mutate: UseMutateFunction<
        AxiosResponse<any, any>,
        unknown,
        IPayload,
        unknown
    >
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setModal: React.Dispatch<React.SetStateAction<IModal>>
}
interface IModal {
    show: boolean
    loanId: number
}
export default function Detail({
    item,
    isLoading,
    mutate,
    setIsOpen,
    setModal,
}: IItemProps) {
    const navigate = useNavigate()
    const { state } = useLocation()
    return (
        <>
            {!isLoading ? (
                <div className=" my-2 text-sm" onClick={() => setIsOpen(false)}>
                    <hr />
                    <div className=" flex justify-between">
                        <p className=" my-2">سرمایه شخصی</p>
                        <p className=" my-2">
                            {Number(item?.poolship?.capital).toLocaleString()}{' '}
                            تومان
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">بدهکاری</p>
                        <p className=" my-2">
                            {Number(
                                item?.poolship?.debit_amount
                            ).toLocaleString()}{' '}
                            تومان
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">شماره در صف انتظار</p>
                        <p className=" my-2">{item?.index}</p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">تعداد وام دریافتی</p>
                        <p className=" my-2">
                            {Number(item?.poolship?.num_loans).toLocaleString()}{' '}
                            وام
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">اعتبار همیانی</p>
                        <p className=" my-2">
                            {item?.poolship?.global_credit.toFixed(1)}
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">تاریخ عضویت</p>
                        <p className=" my-2">
                            {moment
                                .from(
                                    item.poolship.jalali_join_date,
                                    'fa',
                                    'YYYY-MM-DD'
                                )
                                .locale('fa')
                                .format('YYYY')}
                            /
                            {moment
                                .from(
                                    item.poolship.jalali_join_date,
                                    'fa',
                                    'YYYY-MM-DD'
                                )
                                .locale('fa')
                                .format('MM')}
                            /
                            {moment
                                .from(
                                    item.poolship.jalali_join_date,
                                    'fa',
                                    'YYYY-MM-DD'
                                )
                                .locale('fa')
                                .format('DD')}
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">ضامن عضو</p>
                        <p className=" my-2">
                            {item?.poolship?.guarantor
                                ? String(
                                      item?.poolship?.guarantor.member
                                          .first_name
                                  ) +
                                  ' ' +
                                  String(
                                      item.poolship.guarantor.member.last_name
                                  )
                                : 'ثبت نشده'}
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">معرف عضو</p>
                        <p className=" my-2">
                            {item.poolship.recommender
                                ? String(
                                      item.poolship.recommender.member
                                          .first_name
                                  ) +
                                  ' ' +
                                  String(
                                      item.poolship.recommender.member.last_name
                                  )
                                : 'ثبت نشده'}
                        </p>
                    </div>
                    <div className=" flex justify-between">
                        <p className=" my-2">ساعت ثبت درخواست</p>
                        <p className=" my-2">
                            {moment
                                .from(item.created, 'YYYY-MM-DD')
                                .locale('fa')
                                .format('HH:mm:ss')}
                        </p>
                    </div>
                    {/* Full width, not a label/value row: this is a paragraph
                        the member wrote, and the form told them «این پیام فقط
                        برای مدیران قابل مشاهده است» — so the one screen where
                        a manager reads their requests has to show it. */}
                    {!!item.user_description?.trim() && (
                        <div className=" my-2">
                            <p className=" my-2">توضیح عضو</p>
                            <p className=" whitespace-pre-line rounded-lg bg-gray-5 px-3 py-2 leading-7">
                                {item.user_description}
                            </p>
                        </div>
                    )}
                    {state.isManager ? (
                        <div className=" flex justify-between mx-2">
                            <button
                                className=" rounded-md  border-1 border-green-1 bg-green-2 ml-1 text-green-1 py-2 w-full"
                                onClick={(event) => {
                                    event.stopPropagation()
                                    navigate(
                                        `/loans/accept/management/add-new/${item?.poolship?.moneypool}/${item.poolship.id}`,
                                        {
                                            state: {
                                                name: state?.name,
                                                exist: state?.exist,
                                                amount: item.amount,
                                                // The loan goes to whoever the
                                                // request is FOR — `poolship` —
                                                // not to whoever filed it.
                                                // `registrar` is the same person
                                                // on a self-filed request, so
                                                // this only changes the
                                                // filed-on-behalf case, where it
                                                // used to send the wrong member:
                                                // the accept screen loads
                                                // `register`'s bank accounts and
                                                // submits `poolShip: register.id`,
                                                // so `selectedCardNumber` below
                                                // (the BORROWER's card) could
                                                // never match and the screen was
                                                // a dead end — «شماره حساب را
                                                // انتخاب کنید» with nothing to
                                                // pick that would satisfy it.
                                                register: item.poolship,
                                                num_repayment:
                                                    item.num_repayments,
                                                loan_demand: item.id,
                                                selectedCardNumber:
                                                    item.selected_card_number,
                                            },
                                        }
                                    )
                                }}
                            >
                                قبول
                            </button>
                            <button
                                className=" rounded-md bg-transparent border-1 mr-1 border-red-1 text-red-1 py-2 w-full"
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setModal({
                                        show: true,
                                        loanId: item.id,
                                    })
                                }}
                            >
                                لغو
                            </button>
                        </div>
                    ) : (
                        <>
                            {item.is_poolship_requsted_loan && (
                                <button
                                    className=" rounded-md bg-transparent border-1 border-red-1 text-red-1 py-2 w-full"
                                    type="button"
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        setModal({
                                            show: true,
                                            loanId: item.id,
                                        })
                                    }}
                                >
                                    لغو
                                </button>
                            )}
                        </>
                    )}
                </div>
            ) : (
                <DotsLoading />
            )}
        </>
    )
}
